// Sophisticated Modern Theme Colors
// Rich and elegant Dark Mode Colors
export const darkColors = {
  // Primary colors - Bright Teal
  primary: {
    main: '#14a3a8',
    light: '#2dc4ca',
    dark: '#0d7377',
  },
  // Secondary colors - Rich Gold
  secondary: {
    main: '#d4b483',
    light: '#e5cda3',
    dark: '#c49b63',
  },
  // Background colors - Deep and rich
  background: {
    default: '#0f1419', // Deep navy-black
    paper: '#1a2332', // Elevated dark
    elevated: '#252d3d', // Card backgrounds
  },
  // Text colors
  text: {
    primary: '#f7fafc',
    secondary: '#cbd5e0',
    tertiary: '#a0aec0',
    inverse: '#1a2332',
  },
  // Accent colors (more vibrant for dark mode)
  accent: {
    rose: '#e89099',
    sage: '#a5c4a2',
    lavender: '#b5a8d4',
    coral: '#f5b59f',
  },
  // Status colors
  status: {
    success: '#68d391',
    warning: '#f6ad55',
    error: '#fc8181',
    info: '#63b3ed',
  },
  // Border colors
  border: {
    default: 'rgba(226, 232, 240, 0.12)',
    light: 'rgba(226, 232, 240, 0.08)',
    dark: 'rgba(226, 232, 240, 0.24)',
  },
  // Shadow colors
  shadow: {
    light: 'rgba(0, 0, 0, 0.2)',
    medium: 'rgba(0, 0, 0, 0.3)',
    dark: 'rgba(0, 0, 0, 0.4)',
    glow: '0 4px 20px rgba(20, 163, 168, 0.25)',
  },
  // Thermal colors (for TADAR visualization)
  thermal: {
    cold: '#00d4ff',
    cool: '#00ff88',
    warm: '#ffdd00',
    hot: '#ff3300',
  },
};

// Utility function to create thermal gradient
export const createThermalGradient = (angle = 135) => {
  return `linear-gradient(${angle}deg, #00d4ff 0%, #00ff88 25%, #ffdd00 50%, #ff3300 100%)`;
};